export const Any = Symbol("Any");
